import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router, { ROUTE_NAME_ACCOUNT } from './router';

menuRegistry.registerMenu([
    {
        parent: 'SystemWide',
        key: 'Account',
        name: 'Account',
        icon: 'fa fa-users',
        roles: [Role.ADMIN]
    },
    {
        parent: 'SystemWide.Account',
        key: 'New',
        name: 'New',
        icon: 'fa fa-plus',
        route: { name: ROUTE_NAME_ACCOUNT.SYSTEM.ADD }
    },
    {
        parent: 'SystemWide.Account',
        key: 'Password',
        name: 'Password',
        icon: 'fa fa-key',
        route: { name: ROUTE_NAME_ACCOUNT.SYSTEM.PASSWORD }
    },

    {
        parent: 'General',
        key: 'Account',
        name: 'Account',
        icon: 'fa fa-users',
        route: { name: ROUTE_NAME_ACCOUNT.APP.INDEX }
    }
]);

export default registerRouteForModule(router);
